import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'
import { useTrans } from '@next-nx/hooks'
import { Logo, LogoGruppo } from '@next-nx/shared-ui/icons'
import { WContainer } from '@next-nx/shared-ui/atoms'
import styles from './LandingFooter.module.sass'
import { getAnchorRel } from '@next-nx/utils'

interface Props {
  className?: string
}

const LandingFooter = (props: Props) => {
  const { className = '' } = props

  const t = useTrans()

  const menu: MenuItemType[] = [
    {
      pk: 1,
      name: 'Privacy Policy',
      url: 'https://www.unipolrental.it/privacy-policy',
      blank: true,
    },
    {
      pk: 2,
      name: 'Cookie Policy',
      url: 'https://www.unipolrental.it/cookies-policy',
      blank: true,
    },
    {
      pk: 3,
      name: 'Modifica il tuo consenso Cookie',
      url: 'javascript: Cookiebot.renew()',
      blank: false,
    },
  ]

  const social: MenuItemType[] = [
    { pk: 1, style: 'facebook', url: 'https://www.facebook.com/UnipolRental', blank: true },
    {
      pk: 2,
      style: 'linked_in',
      url: 'https://www.linkedin.com/company/unipolrental-s-p-a/?originalSubdomain=it',
      blank: true,
    },
    { pk: 3, style: 'you_tube', url: 'https://www.youtube.com/user/CarServerSpa', blank: true },
    {
      pk: 4,
      style: 'instagram',
      url: 'https://www.instagram.com/unipolrental/?hl=it',
      blank: true,
    },
  ]

  return (
    <div className={`${styles.landingFooter} ${className}`}>
      <div className={styles.top}>
        <WContainer>
          <div className={styles.topContent}>
            <a href="https://www.unipolrental.it" className={styles.logo} target="_blank">
              <Logo />
            </a>
            {menu?.length > 0 && (
              <div className={styles.menu}>
                {menu.map((x) => (
                  <a
                    key={x.pk}
                    href={x.url || ''}
                    className={styles.menuItem}
                    rel={getAnchorRel(x.url || '')}
                    target={x.blank ? '_blank' : undefined}
                  >
                    {x.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </WContainer>
      </div>
      <div className={styles.bottom}>
        <WContainer>
          <div className={styles.bottomContent}>
            {social?.length > 0 && (
              <div className={styles.social}>
                <p className={styles.socialLabel}>{t('Seguici su')}</p>
                <div className={styles.socialMenu}>
                  {social.map((x) => (
                    <a
                      key={x.pk}
                      href={x.url || ''}
                      rel={getAnchorRel(x.url || '')}
                      className={styles.socialMenuItem}
                      target={x.blank ? '_blank' : undefined}
                    >
                      {getIcon(x.style)}
                    </a>
                  ))}
                </div>
              </div>
            )}
            <div className={styles.copyright}>{t('footer_copyright_landing')}</div>
            <div className={styles.logoGruppo}>
              <LogoGruppo />
            </div>
          </div>
        </WContainer>
      </div>
    </div>
  )
}

export default LandingFooter
